import { useState } from "react";

import styled from "styled-components/macro";

import API from "Payments/ManagePaymentMethods/API";
import { useManagePaymentMethods } from "Payments/ManagePaymentMethods/ManagePaymentMethodsContext";
import classNames from "classnames";

import { HoverBackground, HoverParent } from "UI/HoverChildren";

import { usePaymentMethod } from "../PaymentMethodContext";

import { DefaultCardButton, EditButton, ShareButton, TTGButton } from "./";

export default function QuickControls({
  showQuickControls = true,
  hasMultiplePaymentMethods = false,
  hasMobilePhone = false,
  hasOtherOwner = false,
  updateExternalPaymentMethods,
  networkName,
}) {
  const [disabled, setDisabled] = useState(false);
  const {
    dispatch: mpmDispatch,
    state: {
      user: { userID, otherHoHNames },
    },
  } = useManagePaymentMethods();
  const { state } = usePaymentMethod();

  const sharableWith = otherHoHNames;

  if (!showQuickControls && hasOtherOwner) return null;

  // Per OB, we are removing the TTG setting option for now so we are always treating it as if they do not have a mobile phone
  hasMobilePhone = false;

  // there are no quick controls to show if user does not have phone and
  // their only card is a shared card.
  if (hasOtherOwner && !hasMultiplePaymentMethods && !hasMobilePhone)
    return null;

  const insideClass = classNames({
    hasOtherOwner,
    editButtonOnly:
      !showQuickControls ||
      (!hasMultiplePaymentMethods &&
        !hasMobilePhone &&
        (!sharableWith || sharableWith.length === 0)),
    singleButtonOnly:
      hasOtherOwner && (!hasMultiplePaymentMethods || !hasMobilePhone),
  });

  const savePaymentMethod = (updatedData, resolve) => {
    setDisabled(true);
    const postData = { ...state, userID, ...updatedData };
    API.updateSavedPaymentMethod(postData)
      .post()
      .then((resp) => {
        mpmDispatch({
          type: "Set Payment Methods",
          payload: resp.paymentMethods.sort((PM) =>
            PM.isDefaultPaymentMethod ? -1 : 0
          ),
        });
        setDisabled(false);
        resolve();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  return (
    <Wrapper>
      <HoverParent
        hoverStyle={{ background: "rgba(255,255,255,.2)", borderRadius: 12 }}
        hoverMargin={0}
      >
        <Inside className={insideClass}>
          {showQuickControls && (
            <>
              {hasMultiplePaymentMethods && (
                <DefaultCardButton
                  disabled={disabled}
                  savePaymentMethod={savePaymentMethod}
                />
              )}
              {hasMobilePhone && (
                <TTGButton
                  disabled={disabled}
                  savePaymentMethod={savePaymentMethod}
                />
              )}
              {sharableWith?.length > 0 && !hasOtherOwner ? (
                <ShareButton
                  disabled={disabled}
                  savePaymentMethod={savePaymentMethod}
                  sharableWith={sharableWith}
                />
              ) : !hasOtherOwner ? (
                <Spacer />
              ) : null}
              {!hasMobilePhone && <Spacer />}
              {!hasMultiplePaymentMethods && <Spacer />}
            </>
          )}
          {!hasOtherOwner && (
            <EditButton
              disabled={disabled}
              updateExternalPaymentMethods={updateExternalPaymentMethods}
              networkName={networkName}
            />
          )}
        </Inside>
      </HoverParent>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  overflow: hidden;
  border-radius: 14px;
  position: absolute;
  bottom: 4px;
  left: 4px;
  right: 4px;
  z-index: 105;
  color: #fff;
  .card_type_amex & {
    margin: 0 3%;
    border-radius: 4px;
    ${HoverBackground} {
      border-radius: 2px !important;
    }
  }
`;
const Inside = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 2px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  .width_320 & {
    justify-content: space-between;
  }
  &.hasOtherOwner {
    width: 50%;
    .width_360 & {
      width: fit-content;
    }
  }
  &.singleButtonOnly {
    width: 25%;
    .width_360 & {
      width: fit-content;
    }
  }
  &.editButtonOnly {
    width: fit-content;
    margin-left: auto;
  }
  .card_type_amex & {
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.4);
  }
  .card_type_visa & {
    background: rgba(0, 0, 0, 0.3);
  }
`;
const Spacer = styled.div`
  width: 25%;
`;
